export default __webpack_public_path__ + "static/counterfeit_staff_upgrade-504e0c322c6c45bb4b488eaff145af8b.png";